export default "__VITE_ASSET__3d9388c2__"